import styled from "styled-components";
import {device} from "../../styles";
import IconRandom from "../Icons/IconRandom";


export const RandomButton = styled.div`
    width: 43px;
    height: 43px;
    padding: 0;
    border-radius: 50%;
    border: 1px solid #fff;
    cursor: pointer;
    background-color: #fff;
    transition: opacity 0.3s;
    outline: none;

    svg {
        filter: invert();
    }

    ${device.less1180} {
        width: 35px;
        height: 35px;
    }

    ${device.less768} {
        width: 40px;
        height: 40px;
    }

    &:hover {
        opacity: 0.7;

        ${device.less768} {
            opacity: 1;
        }
    }
`;

export const RandomIcon = styled(IconRandom)`
    fill: #fff !important;
`;
